export default "__VITE_ASSET__a7a4b9ac__"